import axios from 'axios';

export async function getPendingRequestCount(endpoint: string): Promise<number> {
    const response = await axios.get(endpoint, {
        timeout: 60000
    });

    return Promise.resolve(response.data.count);
}
